import { ref, watch } from 'vue';
import { SYSTEM_MODALS } from './constants';

const activeDialog = ref(''); // NOTE :: to be used in severe conditions where you need to have more than one ADiloag per view
const activeModal = ref('');
const activeModalProps = ref();
const dialogVisibility = ref(false);
const styles = ref(['w-full sm:w-[600px]']);

export default function () {
  watch(activeModal, () => (activeDialog.value = ''));

  function isCurrentModalOpen(targetModal: SYSTEM_MODALS) {
    return [activeDialog.value, activeModal.value].includes(targetModal);
  }

  function reset() {
    activeDialog.value = '';
    activeModal.value = '';
    activeModalProps.value = '';
    dialogVisibility.value = false;
    styles.value = ['w-full sm:w-[600px]'];
  }

  return {
    activeDialog,
    activeModal,
    activeModalProps,
    dialogVisibility,
    styles,

    SYSTEM_MODALS,

    isCurrentModalOpen,
    reset,
    resetModal: reset,
  };
}
